export { default } from './comment-2-ai'
